import LOGO from "../images/Coyotes.png";

export const Team__Coyotes = {
  name: "Coyotes",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#C97A2B",
  teamJerseyColor: "#111111",

  // Stats
  gamesWon: 3,
  gamesLost: 0,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 47 + 56 + 69,
  goalsScoredAgainst: 40 + 47 + 29,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
